export default {
      id: "demarches_professionnels-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#demarches_professionnels-usage",
      toString: function () {
        return this.url;
      }
    }